/**
 * Configuration for event snapping behavior in timeline editor
 */

/**
 * DIG layer event states - the only valid states for truck cycle boundaries.
 * These are the state values from MachineEvents that belong to the DIG layer.
 * TRUCK layer events (truck-loaded, truck-empty, truck-state-unknown) are NOT allowed.
 */
export const DIG_LAYER_STATES = [
  'dig',
  'dump',
  'swing-empty',
  'swing-loaded',
  'dump-no-truck',
  'boulder-handling',
  'cycle-state-unknown',
] as const;

/**
 * @deprecated Use DIG_LAYER_STATES instead
 */
export const SNAPPABLE_EVENT_TYPES = DIG_LAYER_STATES;

/**
 * Event layers that define cycle boundaries
 * Truck cycles can snap to events in these layers when moving/resizing
 * These are the eventLayer values that will act as snap boundaries
 */
export const SNAPPABLE_EVENT_LAYERS = [
  'dig_events',
] as const;

export type SnappableEventLayer = typeof SNAPPABLE_EVENT_LAYERS[number];

/**
 * Snap threshold in milliseconds
 * Events will snap when within this distance of a boundary
 */
export const SNAP_THRESHOLD_MS = 3000; // 3 seconds

/**
 * Check if an event state is a DIG layer state (valid for cycle boundaries)
 */
export function isDIGLayerState(state: string | undefined): boolean {
  if (!state) return false;
  return DIG_LAYER_STATES.includes(state.toLowerCase() as any);
}

/**
 * @deprecated Use isDIGLayerState instead
 */
export function isSnappableEventType(eventType: string): boolean {
  return isDIGLayerState(eventType);
}

/**
 * Check if an event layer is snappable (cycle boundary)
 */
export function isSnappableEventLayer(eventLayer: string | undefined): boolean {
  if (!eventLayer) return false;
  return SNAPPABLE_EVENT_LAYERS.includes(eventLayer.toLowerCase() as any);
}

/**
 * Snap configuration for visual feedback
 */
export const SNAP_CONFIG = {
  // Visual indicator color when snapping occurs
  indicatorColor: '#3b82f6',
  // Line width for snap indicator
  indicatorWidth: 2,
  // Show snap lines when dragging
  showSnapLines: true,
} as const;
